<template>
    <section class="hero p-0">
        <div class="hero-slider">
            <OwlCarousel class="slider-container"
                         :items="1"
                         :loop="true"
                         :nav="true"
                         :dots="true"
                         :autoplay="true"
                         :autoplayTimeout="6000"
                         :smartSpeed="600"
                         :dotsContainer="'.slider-dots'"
                         :navContainer="'#hero-slider-nav'"
                         :navText="['01', '03']">
                <HeroSlide
                    v-for="(slide, index) in data.items"
                    :key="index"
                    :image="slide.background"
                    :cta="slide.button.content"
                    :url="slide.button.url">
                    <h1 v-html="slide.content"></h1>
                </HeroSlide>

            </OwlCarousel>
            <div id="hero-slider-nav">
                <div class="slider-dots"></div>
            </div>
        </div>

        <div class="scroll-down">
            <a href="#brn-features">
                <i class="bi bi-arrow-left"></i>
            </a>

            <span class="action">Scroll down</span>
        </div>
    </section>
</template>

<script>
import OwlCarousel from "vue-owl-carousel"
import HeroSlide from "./HeroSlide";

export default {
    name: "Hero",
    components: { HeroSlide, OwlCarousel },
    computed: {
        data: function() {
            return this.$parent.$props.content['home-hero-slider'].data;
        }
    }
}
</script>

<style scoped>

</style>
